import React, { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

export type DataTableColumnGroupProps = {
  pinned?: 'left' | 'right';
  className?: string;
  children?: React.ReactNode;
};

export const DataTableColumnGroup = styled(
  forwardRef<HTMLDivElement, DataTableColumnGroupProps>(({ children, ...restProps }) => {
    return <div {...restProps}>{children}</div>;
  })
).withConfig({
  shouldForwardProp: (prop) => !['pinned'].includes(prop),
  displayName: 'DataTableColumnGroup',
})`
  display: flex;
  flex-direction: row;
  z-index: 0;
  ${({ pinned }) =>
    pinned === 'left'
      ? `
  position: sticky;
  left: 0;
  z-index: 1;
  > div:last-of-type > div {
    border-right: solid 3px #f8f4f4;
  }
`
      : pinned === 'right'
      ? `
  position: sticky;
  right: 0;
  z-index: 1;
  > div:first-of-type > div {
    border-left: solid 3px #f8f4f4;
  }
`
      : ``}
`;
